import { axiosInstance, type CustomResponseFormat } from "api/instance";
import { ConceptType } from "./conceptApi";

export const DASHBOARD_DOMAIN = "dashboard";

export const DASHBOARD_DETAIL_ENDPOINT = "detail";

export interface DoneTaskType {
  taskKey: string;
  taskId: string;
}

export interface DoneTaskListByDateType {
  date: string;
  doneTaskList: DoneTaskType[];
}
export interface ScoreListType {
  scoreList: number[];
}

export interface TestResultType {
  anxiety?: ScoreListType;
  depression?: ScoreListType;
  stress?: ScoreListType;
  burnout?: ScoreListType;
}

export interface HistoryType {
  listByDate?: DoneTaskListByDateType[];
}
export interface DashboardType {
  concept: ConceptType;
  history: HistoryType;
  selfCheckResult: TestResultType;
}

export const dashboardApi = {
  load: (pid: string) =>
    axiosInstance.get<CustomResponseFormat<DashboardType>>(
      `${DASHBOARD_DOMAIN}/${DASHBOARD_DETAIL_ENDPOINT}`,
      { params: { pid: pid } }
    ),
};
